import { clsx } from 'clsx';
import React, { FC } from 'react';
import { useController } from 'react-hook-form';
import { FormHelperText } from 'atoms/FormHelperText';
import { FormInput } from 'molecules/Form/FormInput';
import { ITextInput } from 'molecules/Form/FormInput/types';
import styles from './styles.module.css';

export const TextInput: FC<ITextInput> = ({
  control,
  name,
  placeholder,
  maxLength,
  className,
  centered,
  inputClassName,
  id,
  isDisabled,
  inputRef,
  inputProps,
  ...rest
}) => {
  const { field, fieldState } = useController({
    control,
    name,
  });

  return (
    <>
      <FormInput
        id={id}
        isDirty={fieldState.isDirty || !!fieldState.error}
        hasError={!!fieldState.error}
        field={field}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        classes={{
          root: className,
          input: clsx(centered && styles.centered, inputClassName),
        }}
        isDisabled={isDisabled}
        inputRef={inputRef}
        inputProps={inputProps}
        {...rest}
      />
      {!!fieldState.error && (
        <FormHelperText className={clsx(centered && styles.centered)} error>
          {fieldState.error.message}
        </FormHelperText>
      )}
    </>
  );
};
